<template>
  <div class="card" :style="{ width }">
    <div :class="{'scroll-view-bg':listLength&&listLength=='1'}">
      <div class="top flex-center"
      :style="{background:listLength&&listLength=='1'? cardData.goodsType !== 'GIFT'?color01[timeType]: timeType === 'over'? color[timeType]:'linear-gradient(106.02deg, #FFEE82 -2.62%, #F17B48 21.6%, #F06748 39.08%)' :color[timeType]}">
        <img
          :src="
            cardData.goodsType !== 'DISCOUNT'
              ? 'https://img.esenyun.com/images/20200522/560e6b4bf0dd4092bf23f24c29aa1572.png'
              : 'https://img.esenyun.com/images/20200603/58421dcf1a154a62a565a12b191701a3.png'
          "
          style="width:46px; height: 20px;margin-left: -1px;"
        />
        <div
          class="time"
          v-if="timeType === 'over'"
          :style="{ color: textColor[timeType] }"
        >
          秒杀已结束
        </div>
        <div
          class="time"
          v-if="timeType === 'start'"
          :style="{color:listLength&&listLength=='1'? textColor01[timeType]:textColor[timeType]}"
        >
          {{ time }}
        </div>
        <div
          class="time flex-center"
          v-if="timeType === 'end'" 
          :style="{color:listLength&&listLength=='1'? textColor01[timeType]:textColor[timeType]}"
        >
          距离结束
          <van-count-down style="margin-left: 5px;" use-slot :time="time" @change="onChange" @finish="over">
                          <text :style="{color:listLength&&listLength=='1'? textColor01[timeType]:textColor[timeType]}">{{ timeData.hours>9?timeData.hours:'0'+timeData.hours }}:</text>
                          <text :style="{color:listLength&&listLength=='1'? textColor01[timeType]:textColor[timeType]}">{{ timeData.minutes>9?timeData.minutes:'0'+ timeData.minutes}}:</text>
                          <text :style="{color:listLength&&listLength=='1'? textColor01[timeType]:textColor[timeType]}">{{ timeData.seconds>9?timeData.seconds:'0'+timeData.seconds }}</text>
                      </van-count-down>
        </div>
      </div>
      <div class="flex-center c-body">
        <div class="left">
          <div class="flex-center" style="height: 20px;">
            <div class="real-money">
              ￥<span style="font-size: 18px;">{{ cardData.seckillPrice }}</span>
            </div>
            <div class="old" v-if="cardData.originalPrice" :style="{color:cardData.goodsType !== 'DISCOUNT'&&timeType !== 'over'?'#A85755':'#969799'}">
              ￥{{ cardData.originalPrice }}
            </div>
          </div>
          <div class="title van-ellipsis" :style="{maxWidth: listLength&&listLength=='1' ?'480rpx':'170rpx'}">
            {{ cardData.goodsName }}
          </div>
          <div class="subc van-ellipsis" :style="{maxWidth:listLength&&listLength=='1' ?'480rpx':'170rpx',color:cardData.goodsType !== 'DISCOUNT'&&timeType !== 'over'?'#A85755':'#969799'}">
            {{ cardData.description }}
          </div>
        </div>
        <div class="right">
          <img
            :src="cardData.goodsImage"
            style="width: 54px; height:54px;"
            v-if="cardData.goodsType !== 'DISCOUNT'"
          />
          <div class="m-bg flex-center" v-else>
            <div class="discount flex-center">
              <div>{{ discount[0] }}</div>
              <div style="font-size: 10px; margin-bottom: 6px;">
                .{{ discount[1] }}折
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    width: {
      type: String,
      default: '168px',
    },
    type: {
      type: String,
      default: 'DISCOUNT',
    },
    cardData: {
      type: Object,
      default: function() {
        return {}
      },
    },
    listLength:{
      type: String,
      default: '',
    },
  },
  watch: {
    cardData: {
      handler: function(val, oldVal) {
        if (val) {
          const data = val
          console.log(3333, val)
          if (!data.startDate) return ''
          const startDate = this.moment(data.startDate).minute(0)
          const endDate = this.moment(data.startDate)
            .minute(0)
            .add('m', +data.duration)
          if (data.startDate) {
            // 结束时间小于当前时间
            if (endDate < this.moment()) {
              this.timeType = 'over'
              this.time = '秒杀已结束'
            } else {
              // 开始时间大于当前时间（未开始）
              if (startDate > this.moment()) {
                // 判断 开始时间是否大于本日
                if (
                  startDate >=
                  this.moment()
                    .startOf('day')
                    .add('d', 1)
                ) {
                  this.timeType = 'start'
                  this.time = '开始时间 ' + startDate.format('MM-DD HH:mm')
                } else {
                  this.timeType = 'start'
                  this.time = '等待开始 ' + startDate.format('HH:mm')
                }
              } else {
                this.timeType = 'end'
                this.time = endDate.diff(this.moment(), 'ms')
              }
            }
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      timeData:{},
      timeType: '',
      time: '',
      discount: [],
      color: {
        over: '#EBEDF0',
        start: '#FDF6C9',
        end: '#FFEEE8',
      },
      textColor: {
        over: '#4A4A4A',
        start: '#49410F',
        end: '#A20606',
      },
      color01:{
        over: '#EBEDF0',
        start:'linear-gradient(110.58deg, #FFB19D -1.7%, #E54536 30.17%, #DE2B1D 100%)',
        end: 'linear-gradient(110.58deg, #FFB19D -1.7%, #E54536 30.17%, #DE2B1D 100%)'
      },
      textColor01: {
        over: '#4A4A4A',
        start: '#FFF',
        end: '#FFF'
      },
    }
  },
  computed: {},
  mounted() {
    this.deal()
    this.discount = this.getDiscount()
  },
  methods: {
    getDiscount() {
      if (this.cardData.discount) {
        const discount = this.cardData.discount + ''
        const discountArr = discount.split('.')
        if (discountArr.length < 2) {
          discountArr.push(0)
        }
        return discountArr
      } else {
        return [0, 0]
      }
    },
    deal() {
      const data = this.cardData
      console.log(3333, this.cardData)
      if (!data.startDate) return ''
      const startDate = this.moment(data.startDate).minute(0)
      const endDate = this.moment(data.startDate)
        .minute(0)
        .add('m', +data.duration)
      if (data.startDate) {
        // 结束时间小于当前时间
        if (endDate < this.moment()) {
          this.timeType = 'over'
          this.time = '秒杀已结束'
        } else {
          // 开始时间大于当前时间（未开始）
          if (startDate > this.moment()) {
            // 判断 开始时间是否大于本日
            if (
              startDate >=
              this.moment()
                .startOf('day')
                .add('d', 1)
            ) {
              this.timeType = 'start'
              this.time = '开始时间 ' + startDate.format('MM-DD HH:mm')
            } else {
              this.timeType = 'start'
              this.time = '等待开始 ' + startDate.format('HH:mm')
            }
          } else {
            this.timeType = 'end'
            this.time = endDate.diff(this.moment(), 'ms')
          }
        }
      }
    },
    over() {
      this.timeType = 'over'
      this.$emit('finish')
    },
    onChange(e) {
      this.timeData= e.detail
    }
  },
}
</script>

<style lang="less" scoped>
.card {
  width: 168px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  border: 1px solid #fec859;
  background: #fff;
  overflow: hidden;
}
.top {
  height: 20px;
  background: #ffeade;
  justify-content: space-between;
  .time {
    margin-right: 6px;
    font-size: 10px;
    line-height: 20px;
    color: #b72222;
    /deep/.van-count-down {
      font-size: 10px;
      color: #b72222;
      display: inline-block;
      margin-left: 5px;
    }
  }
}
.real-money {
  font-size: 10px;
  color: #f5222d;
  font-weight: bold;
}
.old {
  font-size: 10px;
  line-height: 16px;
  color: #7d7e80;
  text-decoration-line: line-through;
  margin-left: 4px;
}
.title {
  margin: 4px 0 2px 0;
  font-size: 11px;
  line-height: 12px;
  text-align: left;
  max-width: 85px;
  color: #000;
}
.c-body {
  height: 66px;
  padding: 6px;
  justify-content: space-between;
}
.m-bg {
  width: 48px;
  height: 54px;
  justify-content: center;
  background: url('https://img.esenyun.com/images/20200522/b17b2fd2bf37461e972f63154bc0f307.png')
    no-repeat;
  background-size: 100%;
  font-weight: bold;
  font-size: 30px;
  color: #fd533e;
  .discount {
    align-items: flex-end;
  }
}
.right {
  image {
    border-radius: 3px;
  }
}
.subc {
  font-size: 10px;
  line-height: 12px;
  color: #969799;
  max-width: 85px;
  text-align: left;
}
.scroll-view-bg {
  background: url('https://img.nextxx.cn/images/20201110/32c94462d31847079f2134b36266a7f8.png') no-repeat;
  background-size: 100%;
}
</style>
